module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modelBox BoxSave",
    class: {
      'showModelBox': _vm.states
    }
  }, [_c('div', {
    staticClass: "Box"
  }, [_c('div', {
    staticClass: "modelBoxContent"
  }, [_c('span', {
    staticClass: "Icon"
  }, [(_vm.state === 'yes') ? _c('i', {
    staticClass: "iconfont icon-chenggong"
  }) : _vm._e(), _vm._v(" "), (_vm.state === 'no') ? _c('i', {
    staticClass: "iconfont icon-iconfontclosesmall"
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.content))])])]), _vm._v(" "), (_vm.states) ? _c('div', {
    staticClass: "model"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-038b4153","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/hintBox/src/hintBox.vue
// module id = 500
// module chunks = 0